import { httpGet, httpPost, httpPostRaw, httpPut } from "@eres/rest";
import cfg from "./config";
import { CloseRequest, ForwardToOCRequest, JOPRequest, OwnerFeedbackRequest, RequestTenderRequest } from "../../../ownercommitteeapi/entities";
import { JOPUserType } from "../index";

const jopServiceApi = "jopService/";

export function getLookUp( lookupName: string ) {
	return httpGet( cfg.jopAPI().endPoint() + "boardmember/lookup/" + lookupName );
}

export function getJOPServiceCategoryLookup( parentId: number , userType: number ) {
	if(userType === JOPUserType.OWNER)
		return getLookUp( `jop_service_category/parent/${ parentId }` );
	else
		return getLookUp( `jop_service_category_tenant/parent/${ parentId }` );
}

export function getJOPServiceSubCategoryLookup( parentId: number, userType: number ) {
	if (userType === JOPUserType.OWNER)
		return getLookUp( `jop_service_sub_category/parent/${ parentId }` );
	else
		return getLookUp( `jop_service_sub_category_tenant/parent/${ parentId }` );
}

export function getJOPServices( ownerNumber : number , propertyNumber: number ) {
	return httpGet( cfg.jopGateAPI().endPoint() + "jopService/owner/" + `${ ownerNumber }` + "/property/" + `${ propertyNumber }` + "/allowedTypes" );
}

export function getJOPServicesTenant( ownerNumber : number , propertyNumber: number ) {
	return httpGet( cfg.jopGateAPI().endPoint() + "jopService/owner/" + `${ ownerNumber }` + "/property/" + `${ propertyNumber }` + "/tenantAllowedTypes" );
}

export function getJOPServiceTaskStatus() {
	return getLookUp( "jop_service_task_status" );
}

export function getJOPRequest( requestId: number ) {
	return httpGet( cfg.jopAPI().endPoint() + jopServiceApi + `${ requestId }` );
}

export function submitJOPRequest( propertyId: number, request: JOPRequest ) {
	return httpPost( cfg.jopAPI().endPoint() + jopServiceApi + `property/${ propertyId }/submit`, request );
}

export function getJOPRequests( ownerNumber: number, serviceType: number ) {
	return httpGet( cfg.jopAPI().endPoint() + jopServiceApi + `owner/${ ownerNumber }/property/0/jopServiceType/${ serviceType }` );
}

export function uploadJOPDocument( file: File ) {
	const data = new FormData();
	data.append( "", file, file.name );
	return httpPostRaw( cfg.jopAPI().endPoint() + `jopService/file`, data );
}

export function getRequestList( ownerNumber: any ) {
	return httpGet( cfg.jopAPI().endPoint() + "owner/status/" + ownerNumber + "/list" );
}

export function forwardToOc( requestId: number, request: ForwardToOCRequest ) {
	return httpPut( cfg.jopAPI().endPoint() + jopServiceApi + `${ requestId }/forwardToOC`, request );
}

export function requestTender( requestId: number, request: RequestTenderRequest ) {
	return httpPut( cfg.jopAPI().endPoint() + jopServiceApi + `${ requestId }/requestTender`, request );
}

export function closeRequest( requestId: number, request: CloseRequest ) {
	return httpPut( cfg.jopAPI().endPoint() + jopServiceApi + `${ requestId }/closeRequest`, request );
}

export function submitOwnerFeedback( requestId: number, feedback: OwnerFeedbackRequest ) {
	return httpPut( cfg.jopAPI().endPoint() + jopServiceApi + `entry/${ requestId }/submitOwnerFeedback`, feedback );
}
